import CardTitle from '@/components/Tools/CardTitle.vue';
import Header from '@/components/Tools/Header.vue';

export default {
  components: {
    't-header': Header,
    't-card-title': CardTitle
  }
};
